import(/* webpackMode: "eager" */ "/Users/tj-index/LP-Finzy/node_modules/next/dist/client/link.js");
